import Loader from '@/components/loader'
import InputField from '@/components/inputs/text'
import ErrorMessage from '@/components/forms/errorMessage'
import { mapGetters } from 'vuex'

export default {
  components: { Loader, InputField, ErrorMessage },
  data () {
    return {
      data: {
        formType: 'person',
        promotion_scope: {
          website: false,
          website_url: '',
          social_media: false,
          marketing: false,
          email_marketing: false
        },
        agreements: {
          data_truth_regulation: {
            checked: false,
            text: 'Oświadczam, że dane zawarte w formularzu są zgodne z prawdą.'
          },
          online_agreement: {
            checked: false,
            text: `Wyrażam zgodę na zawarcie umowy w formie elektronicznej oraz akceptuję postanowienia
                   <a href="https://punkta.pl/regulaminy/#regulamin-programu-partnerskiego-punkta-autoopen" target="_blank" class="rules">
                   Regulaminu Programu partnerskiego punkta.pl</a>`
          },
          data_processing: {
            checked: false,
            text: `Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z
                   <a href="https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen" target="_blank">
                   Polityką prywatności</a>.`
          }
        },
        loading: false,
        errors: false
      }
    }
  },
  created () {
    this.data.first_name = this.getUser.first_name
    this.data.last_name = this.getUser.last_name
  },
  methods: {
    getError (key, container) {
      if (!this.data.errors) return null
      let errors = this.data.errors
      if (container) {
        if (!errors[container]) return null
        errors = errors[container]
      }
      return errors[key] && errors[key].checked ? errors[key].checked : errors[key]
    },
    submitForm () {
      const form = this.data
      let payload = {
        agreements: form.agreements,
        account_type: form.formType,
        contact_phone: form.phone,
        promotion_scope: form.promotion_scope
      }

      if (form.formType === 'company') {
        Object.assign(payload, { company_name: form.company_name, nip: form.nip })
      } else {
        Object.assign(payload, { first_name: form.first_name, last_name: form.last_name, pesel: form.pesel })
      }

      this.data.loading = true
      this.$store
        .dispatch('sendAccountDetails', payload)
        .then(
          response => {
            this.data.errors = false
            this.data.loading = false
            if (response.code === 200) {
              this.$emit('sendSuccess')
              this.$store.dispatch('getUser', { forceUpdate: true })
            }
          },
          errorResponse => {
            this.data.loading = false
            this.data.errors = errorResponse.errors
          }
        )
    },
    checkAllAgreements () {
      if (this.data.check_all_agreements) {
        let agreements = this.data.agreements
        agreements.data_truth_regulation.checked = true
        agreements.online_agreement.checked = true
        agreements.data_processing.checked = true

        if (this.data.errors && this.data.errors.agreements) {
          this.data.errors.agreements = null
        }
      }
    },
    triggerSingleAgreement (modelName) {
      let agreements = this.data.agreements
      if (this.data.errors && this.data.errors.agreements && agreements[modelName].checked) {
        this.data.errors.agreements[modelName] = null
      }
      if (agreements.data_truth_regulation.checked && agreements.online_agreement.checked &&
          agreements.data_processing.checked) {
        this.data.check_all_agreements = true
      } else {
        this.data.check_all_agreements = false
      }
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  }
}



// WEBPACK FOOTER //
// ./src/components/accountDetailsForm/script.js